export default __webpack_public_path__ + "static/media/dental.1611f42f.svg";